import Vue from "vue";

var ENDPOINTS = {
  save_raw_json: "save",
  get_raw_json: "get",
  generate_form: "generate",
  creditors_autocomplete: "creditors/autocomplete",
  get_list_of_forms: "forms/list",
  generate_reason: "generate_reason"
};

export class Backend {
  constructor(config) {
    this.api_url = config.api_url;
    this.stage = config.stage;
  }

  get_endpoint(name) {
    return `${this.api_url}/${this.stage}/${ENDPOINTS[name]}/`;
  }

  async save_raw_json(config, model, step_id, access_token) {
    var endpoint = this.get_endpoint("save_raw_json");

    var data = {
      config: config,
      model: model,
      step_id: step_id
    };

    var post_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };

    let result = await Vue.axios(post_data);
    return result;
  }

  async get_raw_json(config, access_token) {
    var endpoint = this.get_endpoint("get_raw_json");

    var data = {
      config: config
    };

    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };

    let result = await Vue.axios(get_data);
    return result;
  }

  async generate_form(config, model, step_id, access_token) {
    var endpoint = this.get_endpoint("generate_form");
    var data = {
      config: config,
      model: model,
      step_id: step_id,
      template_name: "template"
    };

    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }

  async autocomplete(searchQuery, creditor_type, access_token) {
    var endpoint = this.get_endpoint("creditors_autocomplete");
    var data = {
      query: searchQuery,
      creditor_type: creditor_type
    };
    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }

  async get_list_generated_forms(access_token) {
    var endpoint = this.get_endpoint("get_list_of_forms");

    var get_data = {
      method: "POST",
      url: endpoint,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }

  async generate_reason(model, access_token) {
    var endpoint = this.get_endpoint("generate_reason");
    var data = {
      merge_fields: model
    };

    var get_data = {
      method: "POST",
      url: endpoint,
      data: data,
      headers: {
        Authorization: access_token
      }
    };
    let result = await Vue.axios(get_data);
    return result;
  }
}
